import { useEffect, useCallback, useMemo } from 'react';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES as MESSAGE_TOPICS } from 'crm-message-bus/types/MessageTopics';

// The following disable directive for no-restricted-imports is intentional. We need to mport it for setup.
// eslint-disable-next-line no-restricted-imports
import GlobalScopesContainer from 'crm-legacy-global-containers/GlobalScopesContainer';
import ScopesContainer from './containers/ScopesContainer';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { QueryContext } from 'customer-data-sidebar/universal/context/QueryContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { PreviewConfigContext } from 'customer-data-sidebar/universal/context/PreviewConfigContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { SourceAppContext } from 'customer-data-sidebar/universal/context/SourceAppContext';
import { ExtraCardPropsContextProvider } from 'crm-cards-sdk/internal/ExtraPropsContext';
import { FETCH_LEGACY_SIDEBAR_SUBJECT } from './FetchLegacySidebarSubjectQuery';
import { useQuery } from '@apollo/client';
import LegacySidebarCardDataContexts from '../../LegacySidebarCardDataContexts';
import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { CardLocationContext } from 'customer-data-sidebar/universal/context/CardLocationContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { EditableAreasContext } from 'customer-data-sidebar/universal/context/EditableAreasContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { SidebarPropertySourceContext } from 'customer-data-sidebar/universal/context/SidebarPropertySourceContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { HostAppCallbacksContext } from 'customer-data-sidebar/universal/context/HostAppCallbacksContext';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
import mark from 'crm-fe-perf/timing/mark';
import measure from 'crm-fe-perf/timing/measure';
import { FetchLegacySidebarSubjectStart, FetchLegacySidebarSubjectFinish } from 'crm-fe-perf/timing/marks/crm-cards-sdk/performanceMarks';
import { FetchLegacySidebarSubject } from 'crm-fe-perf/timing/measurements/crm-cards-sdk/performanceMeasurements';
import { jsx as _jsx } from "react/jsx-runtime";
function cbFor(func) {
  return (...args) => console.log(`${func} called`, ...args);
}
/**
 * SidebarCardLocationWrapper is meant to wrap a CrmCardContainer that contains
 * `LEGACY_SIDEBAR_CARD`. The intent is to provide the functionality that legacy
 * cards need that the adapter can not provide.
 * These are primarily any contexts that the customer-data-sidebar provided to cards
 * that they depended on.
 *
 * To prevent unecessarily wrapped CrmCardContainer, use the MaybeSidebarCardLocationWrapper,
 * this will only programatically decide if the wrapper is necessary and render it if so.
 *
 * In it's developement, the services provided are meant to be placeholders that are implemented
 * overtime, but before release of any type of support for these cards.
 *
 * Sources to track for this:
 *   * https://git.hubteam.com/HubSpot/customer-data-sidebar/blob/master/customer-data-sidebar/static-2.40467/js/universal/UniversalSidebar.js
 *   * https://git.hubteam.com/HubSpot/customer-data-sidebar/blob/master/customer-data-sidebar/static-2.40467/js/universal/UniversalSidebarCardsContainer.js
 *
 */
export function SidebarCardLocationWrapper({
  objectId,
  objectTypeId,
  scopes,
  gates,
  children,
  legacySidebarCardProps,
  editableAreasAtom = universalEditableAreas // Defaulting to universal only because the EditableAreas context REQUIRES one. This is bad form
}) {
  const {
    location,
    loggingTag
  } = useCardLocationContext();
  const sidebarCardLocationContextValue = useMemo(() => {
    return {
      cardLocation: location
    };
  }, [location]);
  const perfDimensions = useMemo(() => ({
    location,
    logging_tag: loggingTag || ''
  }),
  // We don't track it, but we should re-measure whenever the object changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [location, loggingTag, objectId, objectTypeId]);
  useMarkOnMount(FetchLegacySidebarSubjectStart, perfDimensions);
  const query = useQuery(FETCH_LEGACY_SIDEBAR_SUBJECT, {
    variables: {
      objectTypeId,
      objectId
    }
  });
  const {
    loading,
    data
  } = query;
  useEffect(() => {
    if (data) {
      mark(FetchLegacySidebarSubjectFinish, perfDimensions);
      measure(FetchLegacySidebarSubject, perfDimensions);
    }
  }, [data, perfDimensions]);
  const sendPreviewMessage = useSendCrmMessageTopic(MESSAGE_TOPICS.PREVIEW_OBJECT);
  const sendClosePreviewMessage = useSendCrmMessageTopic(MESSAGE_TOPICS.CLOSE_PREVIEW_OBJECT);
  const sendObjectCreatedAction = useSendCrmMessageTopic(MESSAGE_TOPICS.OBJECT_CREATED);
  const sendObjectDeletedAction = useSendCrmMessageTopic(MESSAGE_TOPICS.OBJECT_DELETED);
  const sendUpdateObjectAction = useSendCrmMessageTopic(MESSAGE_TOPICS.UPDATE_OBJECT);
  const sendUpdateAssociationsAction = useSendCrmMessageTopic(MESSAGE_TOPICS.UPDATE_ASSOCIATIONS);
  const openPreview = useCallback(previewRecord => {
    sendPreviewMessage({
      objectId: previewRecord.objectId,
      objectTypeId: previewRecord.objectTypeId
    });
  }, [sendPreviewMessage]);
  const closePreview = useCallback(() => {
    sendClosePreviewMessage();
  }, [sendClosePreviewMessage]);
  useEffect(() => {
    const scopesObj = scopes.reduce((acc, scope) => {
      acc[scope] = true;
      return acc;
    }, {});
    ScopesContainer.set(scopesObj);
    GlobalScopesContainer.setContainer(ScopesContainer);
  }, [scopes]);
  const previewConfig = useMemo(() => {
    return {
      setPreviewConfig: openPreview,
      closeSidebar: closePreview,
      fromObjectId: objectId,
      fromObjectType: objectTypeId
    };
  }, [openPreview, closePreview, objectId, objectTypeId]);
  const __cardStateManipulation = useMemo(() => {
    return {
      onCardOrderChange: cbFor('cardStateManipulation.onCardOrderChange'),
      onCardOpenChange: cbFor('cardStateManipulation.onCardOpenChange')
    };
  }, []);
  const onAssociationUpdate = useCallback(args => {
    const {
      objectId: updatedObjectId,
      objectType: updatedObjectType,
      associationObjectType
    } = args;
    sendUpdateAssociationsAction({
      objectId: String(updatedObjectId),
      objectTypeId: normalizeTypeId(updatedObjectType),
      toObjectTypeId: normalizeTypeId(associationObjectType)
    });
  }, [sendUpdateAssociationsAction]);
  const onObjectCreate = useCallback(args => {
    const {
      associationType,
      objectId: createdObjectId,
      addAnother
    } = args;
    sendObjectCreatedAction({
      objectId: String(createdObjectId),
      objectTypeId: normalizeTypeId(associationType),
      preventRedirect: !!addAnother
    });
  }, [sendObjectCreatedAction]);
  const onObjectDelete = useCallback(args => {
    const {
      objectTypeId: deletedObjectTypeId,
      objectId: deletedObjectId
    } = args;
    sendObjectDeletedAction({
      objectId: String(deletedObjectId),
      objectTypeId: normalizeTypeId(deletedObjectTypeId)
    });
  }, [sendObjectDeletedAction]);
  const onObjectUpdate = useCallback(args => {
    const {
      objectId: updatedObjectId,
      objectType: updatedObjectType,
      properties
    } = args;
    const propertyNames = properties.map((_val, key) => key).toArray();
    sendUpdateObjectAction({
      objectId: String(updatedObjectId),
      objectTypeId: normalizeTypeId(updatedObjectType),
      propertyNames
    });
  }, [sendUpdateObjectAction]);
  return /*#__PURE__*/_jsx(SidebarPropertySourceContext.Provider, {
    value: {
      propertySource: 'CRM_UI',
      // propertySourceId is not needed, but not including it throws errors in the BE Gql, even though the field is marked nullable.
      // Not including a SourceId does the right thing and attributes the update to the user making it.
      // https://hubspot.slack.com/archives/C033M2YTAUB/p1661955830692129?thread_ts=1661868909.538779&cid=C033M2YTAUB
      propertySourceId: ''
    },
    children: /*#__PURE__*/_jsx(SourceAppContext.Provider, {
      value: {
        sourceApp: 'CardSDK'
      },
      children: /*#__PURE__*/_jsx(EditableAreasContext.Provider, {
        value: editableAreasAtom,
        children: /*#__PURE__*/_jsx(CardLocationContext.Provider, {
          value: sidebarCardLocationContextValue,
          children: /*#__PURE__*/_jsx(ExtraCardPropsContextProvider, {
            value: legacySidebarCardProps,
            children: /*#__PURE__*/_jsx(PreviewConfigContext.Provider, {
              value: previewConfig,
              children: /*#__PURE__*/_jsx(HostAppCallbacksContext.Provider, {
                value: {
                  onAssociationUpdate,
                  onObjectCreate,
                  onObjectDelete,
                  onObjectUpdate
                },
                children: /*#__PURE__*/_jsx(LegacySidebarCardDataContexts, {
                  scopes: scopes,
                  gates: gates,
                  loading: loading,
                  data: data,
                  children: /*#__PURE__*/_jsx(QueryContext.Provider, {
                    value: query,
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
}